/* eslint-disable no-underscore-dangle */
import {
  ArrangementResource,
  Resource,
  ResourceType,
} from '@thiememeulenhoff/types';
import { Observable, map } from 'rxjs';

export const _mapThedResource = (
  rootResource: Resource | ArrangementResource,
) => {
  const book = (rootResource.children?.find(
    (resource) => resource.digitalResourceType === 'book',
  ) ?? rootResource) as Resource | ArrangementResource;

  book.streamMetadata = rootResource.streamMetadata;

  return {
    book,
    references: rootResource.children?.find(
      (resource) => resource.digitalResourceType === 'reference-book',
    ),
  };
};

export const _mapAlexResource = (book: Resource | ArrangementResource) => ({
  book,
});

export const _mapResources = (
  resources: Array<Resource | ArrangementResource>,
): {
  book?: Resource | ArrangementResource;
  references?: Resource | ArrangementResource;
} => {
  const resource = resources[0];

  if (!resource) {
    return {};
  }

  if ((resource.alexContentIdentifier ?? '').length > 0) {
    return _mapAlexResource(resource);
  }

  return _mapThedResource(resource);
};

export const mapResources = () => {
  return (source: Observable<Array<Resource | ArrangementResource>>) =>
    source.pipe(map(_mapResources));
};

export const _filterResourcesByType = (
  resources: Array<Resource | ArrangementResource>,
  type: ResourceType,
) => resources.filter((resource) => resource.digitalResourceType === type);

export const filterResourcesByType = (type: ResourceType) => {
  return (source: Observable<Array<Resource | ArrangementResource>>) =>
    source.pipe(map((resource) => _filterResourcesByType(resource, type)));
};
